import { useRequest } from '~/repositories'

/** Saves a new scanned/manual ticket for the authenticated user. */
export const postLottery = (payload: any) => {
	return useRequest('post', `/v1/user/lotteries/`, payload)
}

/** Fetches the user's tickets filtered by status (e.g. pending, won, lost) with pagination. */
export const getLotteriesByStatus = (params: any) => {
	return useRequest('get', `/v1/user/lotteries/`, { params })
}

/** Fetches a single user ticket by its ID. */
export const getLotteryById = (id: number) => {
	return useRequest('get', `/v1/user/lotteries/${id}/`, {})
}

/** Updates an existing ticket (e.g. corrects numbers or purchase date). */
export const putUpdateLotteryById = (id: number, payload: any) => {
	return useRequest('put', `/v1/user/lotteries/${id}/update/`, payload)
}

/** Sends a ticket image to the OCR endpoint for automated number extraction. */
export const postSaveImageTicket = (payload: any) => {
	return useRequest('post', '/v1/user/ocr/', payload)
}

/** Fetches the user's ticket-scan summary indicators (total scanned, total won, etc.). */
export const getIndicators = () => {
	return useRequest('get', `/v1/user/lotteries/indicators/`, {})
}

/** Checks whether a manually entered ticket is already registered for the user. */
export const postCheckRegistered = (payload: any) => {
	return useRequest('post', `/v1/user/lotteries/check-registered/`, payload)
}

/** Checks whether a scanned ticket image is already registered for the user via the OCR endpoint. */
export const postCheckRegisteredImage = (payload: any) => {
	return useRequest('post', `/v1/user/ocr/check-registered/`, payload)
}

export default {
	postLottery,
	getLotteriesByStatus,
	getLotteryById,
	putUpdateLotteryById,
	postSaveImageTicket,
	getIndicators,
	postCheckRegistered,
	postCheckRegisteredImage,
}
